// extracted by mini-css-extract-plugin
export var black = "button-proxy-module--black--af3ff";
export var buttonProxy = "button-proxy-module--buttonProxy--d5cb4";
export var icon = "button-proxy-module--icon--ccf9f";
export var iconAndText = "button-proxy-module--iconAndText--928c6";
export var iconButton = "button-proxy-module--iconButton--46f07";
export var iconHover = "button-proxy-module--iconHover--a97aa";
export var iconWrapper = "button-proxy-module--iconWrapper--8e835";
export var justText = "button-proxy-module--justText--e22d1";
export var lp = "button-proxy-module--lp--76358";
export var newStyle = "button-proxy-module--newStyle--1141b";
export var outline = "button-proxy-module--outline--e1bf3";
export var primary = "button-proxy-module--primary--ec970";
export var secondary = "button-proxy-module--secondary--cda35";
export var small = "button-proxy-module--small--48795";
export var vertical = "button-proxy-module--vertical--149ed";